module.exports = __webpack_public_path__ + "img/img15.052fa760.png";